<template lang="html">
  <div>
    <van-nav-bar
      :fixed="true"
      title="积分商城"
    />
    <div class="integral_shop">
      <ul>
        <router-link tag="li" v-for="(item, index) in interalData" :key="index" :to="`/intDetails/${item.tid}`">
          <div class="int_img">
            <img :src="`http://bbs.jmgo.com/${item.att}`" alt="">
          </div>
          <h3 class="ellipsis">{{item.name}}</h3>
          <b>市场价：{{item.real_price}}</b>
          <span>兑换：{{item.ext_price}}果实</span>
          <div class="link" >立即兑换</div>
        </router-link>
      </ul>
    </div>
    <div class="bottom_null_box"></div>
  </div>
</template>

<script>
import Vue from 'vue'
import utilAxios from '@/utils/axios'
import { NavBar } from 'vant'
import { Toast } from 'vant'

Vue.use(Toast)
Vue.use(NavBar)

export default {

  data (){
    return{
      interalData: []
    }
  },
  beforeCreate() {
    Toast.loading({
      mask: false,
      message: '加载中...'
    })
  },
  created() {
    this.getIntegralMallData()
  },
  methods: {
    getIntegralMallData() {
      utilAxios.get({
        url: ' /new_api.php?module=auction',
        method: 'GET',
        callback: (res) => {
          if (res.data.code == 100) {
            this.interalData = res.data.list
            Toast.clear()
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .integral_shop{
    margin-top: .46rem;
    ul{
      display: flex;
      flex-wrap: wrap;
      margin: 1%;
      li{
        margin: 1%;
        width: 48%;
        // height: 2.5rem;
        background: #fff;
        .int_img{
          width: 100%;
          display: flex;
          height: 1.76rem;
          img{
            margin: auto;
          }
        }
        h3{
          height: .3rem;
          background: #FDEED7;
          text-align: center;
          line-height: .3rem;
          color: #ad692f;
        }
        b{
          display: block;
          text-align: center;
          line-height: .2rem;
        }
        span{
          display: block;
          text-align: center;
          line-height: .2rem;
        }
        .link{
          display: block;
          width: 1rem;
          height: .3rem;
          line-height: .3rem;
          text-align: center;
          border: 1px solid red;
          margin: .1rem;
          margin-left: 50%;
          transform: translateX(-50%);
          color: red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Integral/Integral.vue